import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import './utils/vars.scss';
import './reset.scss';
import { App } from './App';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root'),
);
